import React, { useState } from 'react';

// Hooks
import { DuplicateDashboardProvider } from '@/utils/hooks/dashboard/useDuplicateDashboard';
import useTranslation from '@/utils/hooks/translation/useTranslation';

// Utils
import { post } from '@/utils/client';
import { useRouter } from '@/hooks/utils/useNewRouter';

// Lib
import { CREATE_DASHBOARD } from '@/lib/routes/apiEndpoints';
import { DASHBOARD_VIEW } from '@/lib/routes/privateRoutes';

// Components
import Button from '@/components/base/Button';
import { EditNameModal } from '@/components/pages/custom-dashboards/modals/EditNameModal';

export const CreateDashboardModal = () => {
    const router = useRouter();
    const { t } = useTranslation('dashboard');
    const [dashboardEdit, setDashboardEdit] = useState({
        isEditing: false,
        isLoading: false
    });

    const handleChange = (e) => {
        e && e.preventDefault();
        setDashboardEdit({ ...dashboardEdit, isEditing: !dashboardEdit.isEditing });
    };

    return (
        <DuplicateDashboardProvider defaultValues={{ name: '', social_profiles: [] }}>
            <Button className="create-new-add" icon="plus" onClick={handleChange}>
                {t('create_new_dashboard')}
            </Button>
            <EditNameModal
                isOpen={dashboardEdit.isEditing}
                isLoading={dashboardEdit.isLoading}
                toggle={handleChange}
                onConfirm={async (name) => {
                    setDashboardEdit({ ...dashboardEdit, isLoading: true });
                    const { data } = await post(CREATE_DASHBOARD, { name });
                    router.push(DASHBOARD_VIEW.replace('[id]', data.id));
                }}
                onError={() => {
                    setDashboardEdit({ ...dashboardEdit, isLoading: false });
                }}
                btnLabel={t('dashboard_confirm_btn_label')}
            />
        </DuplicateDashboardProvider>
    );
};
